import React from "react";
import {
  CommercialPage,
  PageIntro,
  SectionNav,
} from "../components/commercial";
import { commercialMetadata } from "./commercial-metadata";
import { track } from "../analytics";
export default function Contact() {
  return (
    <CommercialPage meta={commercialMetadata.contact}>
      <PageIntro
        label="Contact Quantingo"
        title="Tell us what you are trying to build or solve."
      >
        You do not need a complete specification. Share what exists, what is
        getting in the way, and the engineering outcome you need.
      </PageIntro>
      <SectionNav
        links={[
          ["#projects", "Project inquiries"],
          ["#partners", "Partner inquiries"],
        ]}
      />
      <section id="projects" className="section container about-grid">
        <div>
          <p className="eyebrow">Project inquiries</p>
          <h2>Start with the problem.</h2>
          <p className="page-copy">
            A short description is enough to begin. Include the relevant
            technical environment, important constraints and expected timeline
            if you have one.
          </p>
          <a
            className="button page-action"
            href="mailto:contact@quantingo.com?subject=Discuss%20a%20project"
            onClick={() => track("contact_email_click")}
          >
            Discuss your project <span aria-hidden="true">↗</span>
          </a>
          <a
            className="email-link"
            href="mailto:contact@quantingo.com"
            onClick={() => track("contact_email_click")}
          >
            contact@quantingo.com
          </a>
        </div>
        <div className="work-card contact-expectations">
          <p className="eyebrow">What happens next</p>
          <h3>Initial Qualification Call</h3>
          <p>
            <strong>Free, one call of up to 30 minutes.</strong> We discuss the
            problem at a high level, initial context and mutual fit.
          </p>
          <h3>If both sides decide to continue</h3>
          <p>
            <strong>Paid Engineering Assessment, starting at US$100.</strong>{" "}
            This project-definition and engineering work establishes the
            technical and commercial basis before the implementation
            Proposal/quotation.
          </p>
          <p>
            Technical investigation, code review, architecture analysis,
            solution design, detailed scoping, estimates, pricing and
            Proposal/SOW preparation belong to paid work after the call. There
            is no further free qualification work.
          </p>
          <a href="/how-we-work">
            How we work <span aria-hidden="true">↗</span>
          </a>
        </div>
      </section>
      <section id="partners" className="section services-section">
        <div className="container about-grid">
          <div>
            <p className="eyebrow">Partner inquiries</p>
            <h2>Know an engineering opportunity?</h2>
            <p className="page-copy">
              Introduce the opportunity. Quantingo handles technical
              qualification, commercial definition, engineering and delivery.
            </p>
          </div>
          <div className="page-prose">
            <p>
              Mention Referral Partner and tell us about your professional
              background, the companies or industries you work with, and any
              potential opportunity. You do not need to disclose sensitive
              client information to start.
            </p>
            <p>
              The standard referral commission is 10% of eligible project
              revenue actually received by Quantingo.
            </p>
            <a
              className="button page-action"
              href="mailto:contact@quantingo.com?subject=Referral%20Partner"
              onClick={() => track("contact_email_click")}
            >
              Discuss a referral partnership <span aria-hidden="true">↗</span>
            </a>
            <p>
              <a className="text-link" href="/partners">
                Referral Partner Program <span aria-hidden="true">↗</span>
              </a>
            </p>
          </div>
        </div>
      </section>
    </CommercialPage>
  );
}
